module.exports = __webpack_public_path__ + "static/media/team.04fbd662.png";